import { gql } from 'apollo-boost';

export const GET_ADMIN_REMINDER_DEBUG = gql`
    query GetAdminReminderDebug($data: GetAdminReminderDebugInput) {
        getAdminReminderDebug(data: $data) {
            filters {
                limit
                status
                userId
                messageId
            }
            statusCounts {
                status
                count
            }
            jobs {
                id
                userId
                messageId
                reminderVersion
                status
                attempts
                dueAt
                nextRetryAt
                lockedUntil
                completedAt
                cancelledAt
                errorMessage
                replyMessageId
                deliveredPushTokenCount
                lastPushAttemptAt
                scheduledLocallyByInstallationId
                updatedAt
                createdAt
                deviceSummary {
                    totalDevices
                    enabledDevices
                    disabledDevices
                    devicesWithPushToken
                }
                devices {
                    id
                    installationId
                    platform
                    timezone
                    appVersion
                    osVersion
                    deviceModel
                    notificationPermissionStatus
                    notificationsEnabled
                    lastSeenAt
                    updatedAt
                    createdAt
                }
            }
        }
    }
`;
